import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RemainingTasks({ incompleteTasks = {} }) {
  const {
    tests = [],
    assignments = [],
    practicalAssignments = [],
    practicalTests = [],
  } = incompleteTasks;
  const [activeTab, setActiveTab] = useState('tests');
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  const handleNavigation = (item, type) => {
    if (type === 'test') {
      navigate('/student/daily/test');
    } else if (type === 'assignment') {
      switch (item.assignmentSchedule) {
        case 'daily':
          navigate('/student/daily/assignment');
          break;
        case 'weekly':
          navigate('/student/weekly/assignment');
          break;
        case 'monthly':
          navigate('/student/montly/assignment');
          break;
        case 'end assignment':
          navigate('/student/end/assignment');
          break;
        default:
          navigate('/student/view/assignment');
      }
    } else if (type === 'practical') {
      navigate('/student/submit/practicle/assignment');
    } else if (type === 'practicalTest') {
      navigate(`/student/practical/test/${item._id}`);
    }
  };

  const TabButton = ({ tab, label, count }) => (
    <button
      onClick={() => setActiveTab(tab)}
      className={`px-4 py-2 ${
        activeTab === tab
          ? 'border-b-2 border-blue-500 text-blue-600'
          : 'text-gray-500'
      }`}
    >
      {label} ({count})
    </button>
  );

  const TaskCard = ({ item, type }) => {
    const commonFields = (
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-lg font-semibold dark:text-white">
            {item.title}
          </h3>
          <div className="mt-1 text-sm  text-gray-600">
            {type === 'practical' ? (
              <div>Question: {item.question}</div>
            ) : type === 'practicalTest' ? (
              <>
                <div>Start: {formatDate(item.startDate)}</div>
                <div>End: {formatDate(item.endDate)}</div>
              </>
            ) : (
              <>
                <div>Type: {item.type?.toUpperCase()}</div>
                <div>
                  Schedule:{' '}
                  {type === 'test'
                    ? 'N/A'
                    : item.assignmentSchedule}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="text-right text-sm">
          <div className="font-medium dark:text-gray-400">
            {type === 'assignment'
              ? `Duration: ${item.completionTime}`
              : formatDate(type === 'test' ? item.scheduledAt : item.dueDate)}
          </div>
        </div>
      </div>
    );

    return (
      <div
        key={item._id}
        className="cursor-pointer rounded-lg border  p-4 transition-shadow hover:shadow-md"
        onClick={() => handleNavigation(item, type)}
      >
        {commonFields}
      </div>
    );
  };

  return (
    <div className="shadow-l mx-auto w-full max-w-6xl rounded-lg bg-white p-6 dark:bg-navy-800">
      <h2 className="mb-6 text-2xl font-bold dark:text-white">
        Remaining Tasks
      </h2>

      <div className="mb-6">
        <div className="flex border-b">
          <TabButton tab="tests" label="Tests" count={tests?.length || 0} />
          <TabButton
            tab="assignments"
            label="Assignments"
            count={assignments?.length || 0}
          />
          <TabButton
            tab="practical"
            label="Practical"
            count={practicalAssignments?.length || 0}
          />
          <TabButton
            tab="practicalTests"
            label="Practical Tests"
            count={practicalTests?.length || 0}
          />
        </div>
      </div>

      <div className="space-y-4">
        {activeTab === 'tests' &&
          tests?.map((test) => (
            <TaskCard key={test._id} item={test} type="test" />
          ))}

        {activeTab === 'assignments' &&
          assignments?.map((assignment) => (
            <TaskCard
              key={assignment._id}
              item={assignment}
              type="assignment"
            />
          ))}

        {activeTab === 'practical' &&
          practicalAssignments?.map((practical) => (
            <TaskCard key={practical._id} item={practical} type="practical" />
          ))}

        {activeTab === 'practicalTests' &&
          practicalTests?.map((pt) => (
            <TaskCard key={pt._id} item={pt} type="practicalTest" />
          ))}
      </div>
    </div>
  );
}
